import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { scrollTo, scrollToTop } from '@utils/scroll'

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    setTimeout(() => {
      scrollToTop()

      scrollTo({
        top: 0,
        using: document.getElementById('template-content'),
      })
    }, 0)
  }, [pathname])

  return null
}

export { ScrollToTop }
